import { Link } from '@ecomm/framework'
import classNames from 'classnames'
import type { buttonTypes } from './schema'
import { isExternalLink } from './utils'

export function BlockEntryButton({
  buttonText,
  url,
  type,
  onClick
}: {
  buttonText?: string
  url: string
  type: buttonTypes
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void
}) {
  const className = classNames(
    'btn mt-4 !px-4 block w-fit min-w-[190px] !no-underline md:mt-6 md:min-w-[224px]',
    {
      'btn-outlined-secondary btn-outlined': type === 'Secondary Outline',
      'btn-solid-primary': type === 'Primary'
    }
  )

  const commonProps = {
    className,
    'data-testid': `btn-${buttonText}`,
    onClick
  }

  return isExternalLink(url) ? (
    <a {...commonProps} href={url}>
      {buttonText}
    </a>
  ) : (
    <Link {...commonProps} to={url}>
      {buttonText}
    </Link>
  )
}
